import { isAndroid, isIOS } from '@utils';

import { merchantCategoryRoutes } from './merchants';
import { Route } from './utils';

export const Routes: Record<string, Route> = {
  home: {
    label: 'Home',
    url: '/',
  },
  getExtraHelp: {
    label: 'Get Extra Help',
    url: '/',
  },
  guidesAndTips: {
    label: 'Guides & Tips',
    url: '/guides-and-tips',
  },
  app: {
    label: 'The App',
    url: '/about-the-app',
  },
  about: {
    label: 'About',
    url: '/about-us',
  },
  helpCenter: {
    label: 'Help Center',
    url: 'https://support.circleof.com/hc/en-us',
  },
  editorialPolicy: {
    label: 'Editorial Policy',
    url: '/editorial-policy',
  },
  privacyPolicy: {
    label: 'Privacy Policy',
    url: '/privacy-policy',
  },
  cookiePolicy: {
    label: 'Cookie Policy',
    url: 'https://circleof.com/cookie-policy/',
  },
  terms: {
    label: 'Terms & Conditions',
    url: '/terms-and-conditions',
  },
  affiliateDisclosure: {
    label: 'Affiliate Disclosure',
    url: '/affiliate-disclosure',
  },
  ...merchantCategoryRoutes,
};

export const navigateAppStore = (fallback: () => void) => {
  if (isAndroid()) return (window.location.href = 'https://androi.onelink.me/RLP6/c482fd30');
  if (isIOS()) return (window.location.href = 'https://onlyiosnew.onelink.me/Ksq7/eda7b70d');
  return fallback();
};

export * from './merchants';
export * from './posts';
export * from './utils';
